import Vue from 'vue'
import VueRouter from 'vue-router'
import serviceAgreement from '@/views/serviceAgreement'
import agreements from '@/views/agreements'
import privacyPolicy from '@/views/privacyPolicy'
import certAgreement from '@/views/certAgreement'
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
// const modulesFiles = require.context('./modules', true, /\.js$/)

// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   const value = modulesFiles(modulePath)
//   modules.push(value.default)
//   return modules
// }, [])
import personEntryInfo from '@/views/person/entryInfo'
import companyEntryInfo from '@/views/company/entryInfo'
import companyScanningCode from '@/views/company/scanningCode'
import agentScanningCode from '@/views/company/agentScanningCode'
import personScanningCode from '@/views/person/scanningCode'
import companySelectRemittanceType from '@/views/company/selectRemittanceType'
import scanningCode from '@/views/scanningCode'
import authCompleted from '@/views/authCompleted'
import authSuccess from '@/views/authSuccess'
import auth from '@/views/auth'
import authResult from '@/views/authResult'
import authFaceResult from '@/views/authFaceResult'
import index from '@/views/index'
const routes = [
  {
    path: '/serviceAgreement',
    component: serviceAgreement,
    name: 'serviceAgreement',
  },
  {
    path: '/agreements',
    component: agreements,
    name: 'agreements',
  }, {
    path: '/privacyPolicy',
    component: privacyPolicy,
    name: 'privacyPolicy',
  }, {
    path: '/certAgreement',
    component: certAgreement,
    name: 'certAgreement',
  }, {
    path: '/person/entryInfo',
    component: personEntryInfo,
    name: 'personEntryInfo',
  }, {
    path: '/company/entryInfo',
    component: companyEntryInfo,
    name: 'companyEntryInfo',
  }, {
    path: '/company/scanningCode',
    component: companyScanningCode,
    name: 'companyScanningCode',
  }, {
    path: '/company/agentScanningCode',
    component: agentScanningCode,
    name: 'companyAgentScanningCode',
  }, {
    path: '/person/scanningCode',
    component: personScanningCode,
    name: 'personScanningCode',
  }, {
    path: '/company/selectRemittanceType',
    component: companySelectRemittanceType,
    name: 'companySelectRemittanceType',
  },
  {
    path: '/scanningCode',
    component: scanningCode,
    name: 'scanningCode',
  },
  {
    path: '/authCompleted',
    component: authCompleted,
    name: 'authCompleted',
  }, {
    path: '/authSuccess',
    component: authSuccess,
    name: 'authSuccess',
  }, {
    path: '/auth',
    component: auth,
    name: 'auth',
  }, {
    path: '/authResult',
    component: authResult,
    name: 'authResult',
  }, {
    path: '/authFaceResult',
    component: authFaceResult,
    name: 'authFaceResult',
  }, {
    path: '/index',
    component: index,
    name: 'index',
  },
  // ...modules,
  {
    path: '*',
    redirect: {
      name: 'home'
    }
  },
]
const router = new VueRouter({
  scrollBehavior: () => ({
    y: 0,
    x: 0
  }),
  routes
})

router.beforeEach((to, from, next) => {
  next()
})
router.afterEach(() => {
  // console.log(to, from, next)
})
export default router